import PortOpeningRuleOnPrem from './PortOpeningRuleOnPrem';
import WorkflowInstance from '../WorkflowInstance';
import User from '../User';
import { WorkflowState } from '../enums/WorkflowState';
import { Environment } from '../enums/Environment';
import { authenticatedUser } from '../../authentication/authModule';
import { UserRole } from '../enums/UserRole';
import { PortOpeningRequestsDirection } from '../enums/POR/PortOpeningRequestsDirection';
import CartaId from './CartaId';
//import CartaIdComponent from '../viewModels/CartaId/CartaIdComponent';

export default class PortOpeningRequestOnPrem {
    id!: number;

    connectionId!: number;

	portOpeningRules!: PortOpeningRuleOnPrem[];

	workflowInstance!: WorkflowInstance;

	direction!: PortOpeningRequestsDirection;

	contactUser!: User;

	cartaId!: CartaId[];

    submitDate!: Date;

    businessJustification!: string;

    comments!: string;

    approvingUser!: User;

    constructor(obj: any) {
		Object.assign(this, obj);
		this.workflowInstance = new WorkflowInstance(obj.workflowInstance);
		this.direction = new PortOpeningRequestsDirection().fromName(obj.direction?.name);
	}

	isEditable():boolean{
		return false
	}


    canHaveDOAGApproval(): boolean {
		const currentState = this.workflowInstance.currentWorkflowInstanceState.workflowState.value;
		return (
			currentState === WorkflowState.PendingForDOAGApproval.value &&
			(authenticatedUser.userId === this.approvingUser?.id)
		);
	}

    canHaveReviewerApproval(): boolean {
		const currentState = this.workflowInstance.currentWorkflowInstanceState.workflowState.value;
		return (
			currentState === WorkflowState.Submitted.value && authenticatedUser.isInRole(UserRole.PORToOnPremTechReviewer)
		);
    }

	canHaveImplementerApproval(): boolean {
		const currentState = this.workflowInstance.currentWorkflowInstanceState.workflowState.value;
		return (
			currentState === WorkflowState.AwaitingImplementation.value && authenticatedUser.isInRole(UserRole.PORToOnPremTechImplementer)
		);
    }
}